import { Link, useLocation } from "react-router-dom";

const tabs = [
    { path: "/affiliate/dashboard",   label: "Dashboard" },
    { path: "/affiliate/analytics",   label: "Analytics" },
    { path: "/affiliate/links",       label: "Links" },
    { path: "/affiliate/referrals",   label: "Referrals" },
    { path: "/affiliate/commissions", label: "Commissions" },
    { path: "/affiliate/payouts",     label: "Payouts" },
];

/* Sub-nav across affiliate pages. Styled to live inside the same
 * pxl_rightBar_assets shell as the rest of the app. */
export default function AffiliateTabs() {
    const here = useLocation().pathname;
    return (
        <div className="pxl-affiliate-tabs">
            <ul className="pxl-affiliate-tabs-list">
                {tabs.map(t => (
                    <li
                        key={t.path}
                        className={`pxl-affiliate-tab-item ${here.startsWith(t.path) ? "isActive" : ""}`}
                    >
                        <Link to={t.path}>{t.label}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
